import { ThemeIconSizeVariable } from '@caspeco/casper-ui-library.base-ui.theme';
export const iconSizeMap = {
    lg: ThemeIconSizeVariable.Medium,
    md: ThemeIconSizeVariable.Medium,
    sm: ThemeIconSizeVariable.Small,
};
/**
 * Maps a ResponsiveValue of button sizes to corresponding icon sizes.
 *
 * @param size - The ResponsiveValue of the button size.
 * @returns A ResponsiveValue of icon sizes.
 */
export function getIconSizeFromButtonSize(size) {
    // If size is a string, map it directly
    if (typeof size === 'string') {
        return iconSizeMap[size];
    }
    // If size is an array, map each element
    if (Array.isArray(size)) {
        return size.map((s) => s && iconSizeMap[s]);
    }
    // If size is an object, map each property value
    if (typeof size === 'object') {
        const mappedSize = {};
        // Get keys of the size object
        const keys = Object.keys(size);
        keys.forEach((key) => {
            const value = size[key];
            if (value) {
                mappedSize[key] = iconSizeMap[value];
            }
        });
        return mappedSize;
    }
    return undefined;
}
//# sourceMappingURL=icon-button.helper.js.map